import { motion, useInView, useMotionValue, animate } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const STATS = [
  { label: "البراندات العالمية", value: 340, suffix: "+" },
  { label: "عدد العملاء", value: 363, suffix: "+" },
  { label: "عدد التصاميم", value: 4000, suffix: "+" },
  { label: "الطلاب الذين تم تدريبهم", value: 60, suffix: "+" },
];

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, value, {
      duration: 2.4,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.floor(v)),
    });
    return () => controls.stop();
  }, [inView, value, mv]);

  return (
    <span ref={ref} className="tabular-nums">
      {display.toLocaleString("en-US")}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-24 md:py-32 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.9, delay: i * 0.08 }}
              className="flex flex-col gap-3"
              data-testid={`stat-item-${i + 1}`}
            >
              <div className="font-display text-5xl md:text-6xl lg:text-7xl font-semibold tracking-[-0.04em] leading-none text-white">
                <Counter value={s.value} suffix={s.suffix} />
              </div>
              <div
                className="font-arabic text-sm md:text-base font-bold text-white/85 leading-snug text-left"
              >
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
